import { css, useTheme } from '@fable/theme'

export const BookGraphic = ({
  color,
  right = false,
}: {
  color?: string
  right?: boolean
}) => {
  const { colors } = useTheme()

  return (
    <div
      className={css`
        display: block;
        width: min(36.667vw, 154px);
        height: min(56.429vw, 237px);
        background-color: ${colors.uiWhite};
        border-radius: 8px;
        overflow: hidden;
        position: absolute;
        left: ${right ? 'auto' : '10%'};
        right: ${right ? '10%' : 'auto'};
        bottom: -45px;
        transform: rotate(${right ? 10 : -10}deg);
        z-index: ${right ? 1 : 3};
        opacity: ${right ? 0.8 : 1};
        box-shadow: 11.8136px 7.87575px 19.6894px rgba(0, 0, 0, 0.2);
      `}
    >
      <img
        className={css`
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 8px;
          border: 2px solid;
          border-color: ${color}90;
          object-fit: cover;
        `}
        src="https://images.ctfassets.net/005nulnwwll2/62ja50Ovbjwsh00TtXn5pn/5085ffbfef8f32d2fe0b12025c6673b9/promo_book.webp"
        alt="promo book"
      />
    </div>
  )
}
